(ns pfo.bulk.controller (:require
                          [clojure.string :refer [trim replace]]
                          [pfo.api :as api  :refer [process-error]]
                          [pfo.bulk.model :as model]
                          [promesa.core :as p]
                          [pfo.collection.model :as collection-model]
                          [keechma.next.controller :as ctrl]
                          [pfo.util :as util :refer [to-value bool-param]]))

(derive :bulk-apply-items :keechma/controller)

;; (defmethod ctrl/start :bulk-apply-items [_ _ _ _]
;;   "initial value")
(defmethod ctrl/handle :bulk-apply-items
  [{:keys [state*] :as ctrl} event {:keys [group-id operation-id page]}]
  (case event
    :load (->> (model/bulk-operation group-id operation-id)
         (p/map
           (fn [details-response]
             (->> (model/bulk-apply-items group-id operation-id page)
                  (p/map
                    (fn [items-response]
                      (let [collection-ids (set (mapv :collection_id (:results items-response)))]
                        (->> (collection-model/sortable-collection-list (into [] collection-ids) nil "name" (count collection-ids))
                             (p/map
                               (fn [collections-response]
                                 (ctrl/transact ctrl #(reset!
                                    state*
                                    {:details details-response
                                     :items items-response
                                     :collections (:results collections-response)
                                     :collection-map (into {} (map (fn [col] [(:id col) col]) (:results collections-response)))
                                     :collection-ids-ordered-unique (mapv (comp :collection_id first ) (partition-by :collection_id (:results items-response)))
                                     :collection-applications (group-by :collection_id (:results items-response))}))))
                             (process-error)))))
                  (process-error)))))
    nil))

(derive :bulk-operations :keechma/controller)

(defmethod ctrl/handle :bulk-operations
  [{:keys [state*] :as ctrl} event {:keys [group-id page]}]
  (case event
    :load (->> (model/bulk-operations group-id page)
               (p/map (fn [ops] (ctrl/transact ctrl #(reset! state* ops))))
               (process-error))
    nil))

(derive :bulk-operation :keechma/controller)

(defmethod ctrl/handle :bulk-operation
  [{:keys [state*] :as ctrl} event {:keys [group-id operation-id]}]
  (case event
    :load (->> (model/bulk-operation group-id operation-id)
               (p/map (fn [ops] (ctrl/transact ctrl #(reset! state* ops))))
               (process-error))
    nil))
